// removed by extract-text-webpack-plugin
module.exports = {"root":"CookieWarning__root--2SXrE","isActive":"CookieWarning__isActive--2Hhi2","adSlot":"CookieWarning__adSlot--3OccD","message":"CookieWarning__message--2lj7T","okay":"CookieWarning__okay--2zSRV","closeButton":"CookieWarning__closeButton--3s5Ux","closeIcon":"CookieWarning__closeIcon--1fjep","bounce":"CookieWarning__bounce--T5OUq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/CookieWarning/CookieWarning.css
// module id = ./src/components/Library/CookieWarning/CookieWarning.css
// module chunks = 4